const palette = {
  orange: '#F36F20',
  Black: '#212224',
  Darkgray: '#9D9D9D',
  Lightgray: '#EBEBEB',
};

export default palette;
